import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, usePage, useResource, useToast } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { BASE, APIS, URLS, SF_PRE_VRFN_DOC_INFO } from "@/tra/tancis/ptli/comnmdle/doc/services/PtliDocMgmtService";

/*
 * Pre-Verification Document Modification
 * !== 사전검증 문서 수정 ==!
 */
export const PTLI0412003S = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0025" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { dclaDocCd } = useParams();
    const modal = useModal();
    const toast = useToast();

    const form = {
        docInfo: useForm({
            defaultSchema: SF_PRE_VRFN_DOC_INFO,
        }),
    };

    const fetch = {
        getPreVrfnDocInfo: useFetch({
            api: () => APIS.getPreVrfnDocInfo(dclaDocCd),
            onSuccess: (data: any) => {
                // 데이터가 없을 경우
                if (!data.preVrfnDocInfo.content) {
                    modal.openModal({ content: "msg.com.00034" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    navigate(`${URLS.ptli0412001q}?menuId=${menuId}`);
                    return;
                }
                form.docInfo.setValues(data.preVrfnDocInfo.content);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        updatePreVrfnDocInfo: useFetch({
            api: (info: any) => APIS.updatePreVrfnDocInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00059" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00022" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
        deletePreVrfnDocInfo: useFetch({
            api: (dclaDocCd: any) => APIS.deletePreVrfnDocInfo(dclaDocCd),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00060" }); // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                navigate(`${URLS.ptli0412001q}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00023" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli0412001q}?menuId=${menuId}`),
        onUpdateBtnClick: form.docInfo.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.com.00050", // Confirm update? !== 수정하시겠습니까? ==!
                    onConfirm: () => fetch.updatePreVrfnDocInfo.fetch(form.docInfo.getValues()),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deletePreVrfnDocInfo.fetch(form.docInfo.getValue("dclaDocCd")),
            });
        },
    };

    useEffect(() => {
        fetch.getPreVrfnDocInfo.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.bsopClsfCd} readOnly={true} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.dclaDocCd} readOnly={true} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docIntfId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docMakeUrlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docNmEn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docNmTz} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.preValdnYn} />
                            <Group.Control {...form.docInfo.schema.useYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.dclaCoTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.rmrk} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section></Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onUpdateBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onDeleteBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
